import type { AppConfigDocument } from '@/api/appConfig';

/**
 * Карточка «Запись голоса» в админке (промпт 22, решение владельца 18.10.2026): номер у каждой записи, хранение
 * записей файлом, сжатие.
 *
 * 🔴 ОТСУТСТВИЕ КЛЮЧА — «ВЫКЛЮЧЕНО». Общий список возможностей (`isFeatureEnabled`) считает ненастроенную
 * возможность включённой — и прав для разделов ученика: они работают, пока их не выключили. У этих флагов
 * умолчание во фронте `false` (`lib/appConfig.ts` DEFAULTS), на проде 17.10 оба ключа записаны `false`, а на
 * стенде или после пересоздания документа их может не быть вовсе — показать тогда «вкл» значит соврать
 * администратору о том, что видят ученики.
 *
 * Сжатие — не любое число, а выбор: 0 (выключено, как решает браузер), 32 или 64 кбит/с. Если в документе лежит
 * другое число (поставили руками), оно показывается как есть и не перетирается молча.
 *
 * ⚠️ ПРОВЕРЕНО НА ТЕЛЕФОНЕ 28.10.2026 (шнур, iPhone владельца, `docs/tasks/T1-ios-1.1.2-submit.md`): iPhone пишет моно
 * ≈184 кбит/с, 64 000 — файл ÷2,9, 32 000 — ÷5,4, оба на слух годятся; отправка без связи со сжатием — ок.
 * Предупреждение «не включать» снято, на проде владелец ставит 64 (произношение важно кураторам).
 * ⚠️ 32 НЕ УБИРАТЬ ПО СИМУЛЯТОРУ: симулятор пишет стерео с микрофона мака, и там WebKit молча отвергает всё ниже
 * 64 000 — 28.10 по этому замеру 32 уже убирали по ошибке и вернули.
 */
export const RECORD_CLIENT_ID_KEY = 'features.record_client_id';
export const OFFLINE_RECORDS_KEY = 'features.offline_records';
export const RECORD_BITRATE_KEY = 'limits.recordBitrate';

export const BITRATE_CHOICES = [0, 32000, 64000] as const;
export type BitrateChoice = (typeof BITRATE_CHOICES)[number];

export type RecordVoiceFlags = {
  clientId: boolean;
  offline: boolean;
  /** 0 / 32000 / 64000 — или другое число, если его поставили мимо карточки */
  bitrate: number;
  /** число в документе не из выбора — карточка показывает его отдельно */
  bitrateCustom: boolean;
};

export function readRecordVoiceFlags(doc: AppConfigDocument | undefined): RecordVoiceFlags {
  const f = doc?.features ?? {};
  const raw = doc?.limits?.recordBitrate;
  // Как читает приложение (`recordBitrate()`): вне 8000–256000 — ноль.
  const bitrate = typeof raw === 'number' && raw >= 8000 && raw <= 256000 ? Math.round(raw) : 0;
  return {
    clientId: f.record_client_id === true,
    offline: f.offline_records === true,
    bitrate,
    bitrateCustom: !(BITRATE_CHOICES as readonly number[]).includes(bitrate),
  };
}

/** Значение для сервера из выбора в карточке. Ничего, кроме трёх вариантов, карточка не отправляет. */
export function bitrateValue(choice: BitrateChoice): number {
  return choice;
}
